<template>
  <v-card class="rounded-card" style="height: 100%;" color="white">
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: "simple_card"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.rounded-card {
  border-radius: 4px;
}
</style>
